<template>
  <card class="text-center">
    <h5 class="title text-center">
      Invitations
    </h5>
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <h6 class="text-primary mb-2">
            Gospel Presentation
          </h6>
          <div v-if="person.received_gospel_presentation" class="text-center">
            <span class="d-inline-block mr-3 text-muted">
              <strong>Date:</strong> {{ formatInvitationDate(person.gospel_presentation_date) || 'N/A' }}
            </span>
            <span class="d-inline-block mr-3">
              <strong class="text-muted">Response:</strong>
              <span class="text-muted">
                {{ person.gospel_presentation_answer || 'N/A' }}
              </span>
            </span>
            <span v-if="person.gospel_presenter" class="d-inline-block mr-3 text-muted">
              <strong>Presenter:</strong> {{ person.gospel_presenter }}
            </span>
            <div v-if="person.gospel_presentation_notes && !isOneOfTheseRoles(['student'])" class="text-muted mt-1">
              <small><strong>Notes:</strong> {{ person.gospel_presentation_notes }}</small>
            </div>
          </div>
          <div v-else class="text-muted">
            <small>No gospel presentation recorded</small>
          </div>
        </div>

        <div>
          <h6 class="text-primary mb-2">
            High Call
          </h6>
          <div v-if="person.received_high_call" class="text-center">
            <span class="d-inline-block mr-3 text-muted">
              <strong>Date:</strong> {{ formatInvitationDate(person.high_call_date) || 'N/A' }}
            </span>
            <span class="d-inline-block mr-3">
              <strong class="text-muted">Response:</strong>
              <span :class="getHighCallResponseClass(person.high_call_answer)">
                {{ person.high_call_answer || 'N/A' }}
              </span>
            </span>
            <span v-if="person.high_call_presenter" class="d-inline-block mr-3 text-muted">
              <strong>Presenter:</strong> {{ person.high_call_presenter }}
            </span>
            <div v-if="person.high_call_notes && !isOneOfTheseRoles(['student'])" class="text-muted mt-1">
              <small><strong>Notes:</strong> {{ person.high_call_notes }}</small>
            </div>
          </div>
          <div v-else class="text-muted">
            <small>No high call recorded</small>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
export default {
    name: 'InvitationCard',
    props: {
        person: {
            type: Object,
            required: true
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        formatInvitationDate(dateString) {
            if (!dateString) return '';
            // Parse the date as UTC to avoid timezone conversion issues
            const date = new Date(`${dateString}T00:00:00`);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        },
        getHighCallResponseClass(response) {
            if (!response) return '';
            switch (response.toLowerCase()) {
            case 'green':
                return 'text-success';
            case 'yellow':
                return 'text-warning';
            case 'red':
                return 'text-danger';
            default:
                return '';
            }
        }
    }
};
</script>
